
import axios from "axios";
import { reactive,ref } from "vue";
import { loading, errors, toast ,meta, loadingBtn, remove } from "./shared";

export default function useCampaignType(navigation) {
  const { route, router } = navigation;
  const campaignTypes = ref([]);
const initCampaignType = {status: 1};
const campaignType = reactive({...initCampaignType});
  const getCampaignTypes = async (query = {}) => {
    try {
      errors.value = "";
      loading.value = true;
      const search = isObjectNotEmpty(query) ? "?" + new URLSearchParams(query).toString() : "";
      let response = await axios.get("user/campaign-type" + search);
      loading.value = false;
      campaignTypes.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const getCampaignType = async () => {
    try {
      errors.value = "";
      loading.value = true;
      let response = await axios.get("user/campaign-type/" + route.params.id);
      loading.value = false;
      Object.assign(campaignType,response.data.data);
    } catch (e) {
      errors.value = e;
      loading.value = false;
    }
  };

  const storeCampaignType = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.post("user/campaign-type",campaignType);
      loadingBtn.value = false;
      toast.success(response.data.message);
      document.getElementById("add-edit-modal").checked = false;
      getcampaignTypes();
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const updateCampaignType = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.put("user/campaign-type/" + campaignType.id, campaignType);
      const index = campaignTypes.value.findIndex((item) => item.id === campaignType.id);
      campaignTypes.value[index] = response.data.data;
      loadingBtn.value = false;
      toast.success(response.data.message);
      document.getElementById("add-edit-modal").checked = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const removeCampaignType = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/campaign-type/" + campaignType.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
      document.getElementById("delete-modal").checked = false;
      getCampaignTypes(route.query);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const clearCampaignType = () => initObject(campaignType, initCampaignType);

  return {
    campaignTypes,
    campaignType,
    clearCampaignType,
    getCampaignTypes,
    getCampaignType,
    storeCampaignType,
    updateCampaignType,
    removeCampaignType,
  };
}
